import React from "react";

export default class StatisticsPage extends React.Component {
  render() {
    return <div>v2</div>;
  }
}
